module.exports = __webpack_public_path__ + "static/media/dungeon_exit.a5dbe5cd.png";